import { isNil, prop } from 'ramda';

import { revokeComingFromUrl } from '@gef-ui/delegations/utils';
import { getIascData } from '@gef-ui/features/iasc/selectors';
import { getMessage } from '@gef-ui/localization/messages';

import campaigns from 'features/views/campaignDashboards/campaigns';
import { changeViewDependingOnRole } from 'features/views/campaignDashboards/structure/actions';
import user from 'features/views/user';
import { getRoutePath, history } from 'utils';

// eslint-disable-next-line import/no-cycle
import { errorRedirect } from '../actions';

const checkInputParams = (campaignId) => {
	const errMsgs = [];
	if (isNil(campaignId)) {
		errMsgs.push(getMessage('iasErrors:missingRequiredParam', { paramName: 'campaignId' }));
	}
	return errMsgs;
};

export default async (dispatch, getState) => {
	const { campaignId } = getIascData(getState());
	const errMsgs = checkInputParams(campaignId);
	const redirected = true;
	if (errMsgs.length > 0) {
		dispatch(errorRedirect(errMsgs));
		throw {};
	} else {
		try {
			await dispatch(campaigns.actions.fetchCampaign(Number(campaignId)));
			await dispatch(user.actions.fetchAdditionalUserInfo());
		} catch (error) {
			history.push('/login/error', { error: prop('parsedContent', error) });
			return Promise.reject();
		}
		dispatch(changeViewDependingOnRole(Number(campaignId), redirected));
		revokeComingFromUrl();
		history.push(getRoutePath('campaigns'));
	}
};
